"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAmountFormatSelector = createAmountFormatSelector;
/*
 UI to select a unit and a number of decimals independently of each other
 */
const React = __importStar(require("react"));
const uom_1 = require("@genesys/uom");
const react_properties_selector_1 = require("../react-properties-selector");
const defaultClearButton = (props) => React.createElement("button", Object.assign({}, props));
const defaultCancelButton = (props) => React.createElement("button", Object.assign({}, props));
const defaultPrecisionSelector = (props) => React.createElement("select", Object.assign({}, props));
const defaultUnitSelector = (props) => React.createElement("select", Object.assign({}, props));
const defaultFormatWrapper = react_properties_selector_1.AmountFormatWrapper;
function createAmountFormatSelector({ ClearButton = defaultClearButton, CancelButton = defaultCancelButton, PrecisionSelector = defaultPrecisionSelector, UnitSelector = defaultUnitSelector, AmountFormatWrapper = defaultFormatWrapper }) {
    return class AmountFormatSelector extends React.Component {
        constructor(props) {
            super(props);
            this.state = { active: false };
        }
        componentDidUpdate(_, prevState) {
            if (this.props.onFormatSelectorActiveChanged &&
                prevState.active !== this.state.active) {
                this.props.onFormatSelectorActiveChanged(this.state.active);
            }
        }
        render() {
            const { selectedUnit, selectedDecimalCount, userSelected, onFormatChanged, onFormatCleared } = this.props;
            // If there is no handler for onFormatChanged then the user should not be able to change the format
            if (!this.state.active || !onFormatChanged) {
                const format = uom_1.Format.getUnitFormat(selectedUnit, uom_1.UnitsFormat);
                return (React.createElement(AmountFormatWrapper, { active: this.state.active, style: (userSelected && { fontWeight: "bold" }) || undefined, onClick: () => this.setState({ active: true }) }, format ? format.label : ""));
            }
            // Get a list of all units within the quantity
            const units = uom_1.Format.getUnitsForQuantity(selectedUnit.quantity);
            const unitNames = units.map(u => uom_1.Serialize.unitToString(u));
            const selectedUnitName = uom_1.Serialize.unitToString(selectedUnit);
            const decimalCounts = [0, 1, 2, 3, 4, 5];
            if (decimalCounts.indexOf(selectedDecimalCount) === -1) {
                decimalCounts.push(selectedDecimalCount);
            }
            return (React.createElement(AmountFormatWrapper, { active: this.state.active },
                React.createElement(UnitSelector, { value: selectedUnitName, onChange: (e) => {
                        this.setState({ active: false });
                        _onUnitChange(e, units, selectedDecimalCount, onFormatChanged);
                    } }, units.map((u, index) => {
                    const format = uom_1.Format.getUnitFormat(u, uom_1.UnitsFormat);
                    return (React.createElement("option", { key: unitNames[index], value: unitNames[index] },
                        " ",
                        format ? format.label : "",
                        " "));
                })),
                React.createElement(PrecisionSelector, { value: selectedDecimalCount.toString(), onChange: (e) => {
                        this.setState({ active: false });
                        _onDecimalCountChange(e, selectedUnit, onFormatChanged);
                    } }, decimalCounts.map(dc => (React.createElement("option", { key: dc.toString(), value: dc.toString() }, dc)))),
                onFormatCleared && (React.createElement(ClearButton, { onClick: () => {
                        this.setState({ active: false });
                        onFormatCleared();
                    } }, "\u00A0")),
                React.createElement(CancelButton, { onClick: () => this.setState({ active: false }) }, "\u00A0")));
        }
    };
}
function _onDecimalCountChange(e, selectedUnit, onFormatChanged) {
    const selectedIndex = e.currentTarget.selectedIndex;
    const selectedDecimalCount = selectedIndex;
    onFormatChanged(selectedUnit, selectedDecimalCount);
}
function _onUnitChange(e, 
// biome-ignore lint: -
units, selectedDecimalCount, onFormatChanged) {
    const selectedIndex = e.currentTarget.selectedIndex;
    const selectedUnit = units[selectedIndex];
    onFormatChanged(selectedUnit, selectedDecimalCount);
}
//# sourceMappingURL=amount-format-selector.js.map